import { BrandAvatarVariants, BrandAvatarSizes, } from "./constants";
import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
const { size } = ids || {};
const getBrandFormat = (variant) => {
    switch (variant) {
        case BrandAvatarVariants.rounded:
            return css `
        border-radius: ${size.general.ids_size_general_80x};
      `;
        case BrandAvatarVariants.placeholder:
            return css `
        border-radius: ${size.general.ids_size_general_80x};
      `;
    }
    return css `
    border-radius: ${size.general.ids_size_general_12x};
  `;
};
const getBrandSize = (brandSize) => {
    switch (brandSize) {
        case BrandAvatarSizes.small:
            return css `
        width: ${size.general.ids_size_general_24x};
        height: ${size.general.ids_size_general_24x};
      `;
        case BrandAvatarSizes.medium:
            return css `
        width: ${size.general.ids_size_general_32x};
        height: ${size.general.ids_size_general_32x};
      `;
        case BrandAvatarSizes.large:
            return css `
        width: ${size.general.ids_size_general_48x};
        height: ${size.general.ids_size_general_48x};
      `;
        case BrandAvatarSizes.huge:
            return css `
        width: ${size.general.ids_size_general_64x};
        height: ${size.general.ids_size_general_64x};
      `;
        default:
            return css `
        width: ${size.general.ids_size_general_24x};
        height: ${size.general.ids_size_general_24x};
      `;
    }
    return;
};
export const BrandAvatarContainer = styled.div `
  box-sizing: border-box;
`;
export const StyledBrandAvatar = styled.img `
  ${({ brandSize }) => getBrandSize(brandSize)}
  ${({ variants }) => getBrandFormat(variants)}
`;
export const StyledPlaceHolder = styled.div `
  ${({ brandSize }) => getBrandSize(brandSize)}
  ${({ variants }) => getBrandFormat(variants)}
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=BrandAvatar.style.js.map